export const isDescription = (value) => typeof value === "object" &&
    value !== null &&
    "type" in value &&
    typeof value.type === "string";
